import { render } from "./DeleteConfirmModal.vue?vue&type=template&id=0c3dfadb"
import script from "./DeleteConfirmModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__